import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'kebabCase' })
export class KebabCasePipe implements PipeTransform {
    transform(value: string): string {
        if (!value || typeof value !== 'string') {
            throw new Error('Value must be a non-empty string');
        }

        // Check if it's SCREAMING_SNAKE_CASE (e.g., EMPLOYEE_EXIT)
        if (value === value.toUpperCase() && value.includes('_')) {
            return value.toLowerCase().replace(/_/g, '-');
        }

        // Check if it's camelCase or PascalCase (e.g., isOnParentalLeave)
        return value
            .replace(/([a-z0-9])([A-Z])/g, '$1-$2') // Insert hyphen between lowercase and uppercase
            .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2') // Handle consecutive uppercase letters
            .toLowerCase();
    }
}
